import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/types';
import DnWidgets from '../dnWidgets';
import Popular from '../Popular';
import { PopularSuggestion } from 'types/searchSuggestion';

interface Props {
  handlePopularSearchClick: (
    suggestion: PopularSuggestion,
    position: number
  ) => void;
}

const PopularSuggestions = ({ handlePopularSearchClick }: Props) => {
  const showDnWidgets = useSelector(
    (state: State) => state.remoteConfig.switches?.searchDNWidgetsEnabled
  );

  if (showDnWidgets) {
    return <DnWidgets />;
  }

  return <Popular handleClick={handlePopularSearchClick} />;
};

export default PopularSuggestions;
